/**
 * @file 応募のメーラー設定
 *
 */

 
 /**
  * @classname MailerSettings
  * @classdesc メーラー設定
  */
 export default class MailerSettings {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('MailerSettings.constructor');
		this._$e = $e;
		const mailId = $e.attr('data-mail-id')

		let contactMail
		switch (mailId) {
			case '1':
				contactMail = this.init_1();
				break
			case '2':
				contactMail = this.init_2();
				break;
			case '3':
				contactMail = this.init_3();
		}
		this._$e.attr('href', contactMail);
		$e.on('click', () => this.onClick());
	};

	/**
	 * click
	 *
	 * @memberof MailerSettings
	 * @return {undefined}
	 */
	onClick() {
		console.log('MailerSettings.onClick');
	}

	/**
	 * 応募メール作成
	 *
	 * @memberof MailerSettings
	 * @return {undefined}
	 */
	init_1() {
		console.log('MailerSettings.init 1:応募メール');
		const lineFeed = "\r\n";
		const to = 'mailto:resort@a-sta.jp';
		//const to = 'mailto:resort@atest.jp';
	
		let mail = '';
		let subject = '';
		let body = '';
		let signature = '';
		let signature2 = '';
	
		const maxlen = 261;
		console.log('to::' + to);
	
		const staff_name = $('#staff_name').val()
	
		const staff_id = $('#staff_id').val()
		const job_no = $('#job_no').text()
		let office_name = $('#facility_name').text()
		const occupation = $('#occupation').val()
	
		const userAgent = navigator.userAgent;
	
		//office_name = '軽井沢ホテル軽井沢ホテル軽井沢ホテル軽井'
		// windows Chrome、もしくはEdgeの場合は、勤務先名を15文字以内にする
		if (
			(userAgent.indexOf('Windows') !== -1 || 
			userAgent.indexOf('Win16') !== -1 || 
			userAgent.indexOf('Win32') !== -1 || 
			userAgent.indexOf('Win64') !== -1) 
			&& 
			userAgent.indexOf('Android') === -1
			&&
			(userAgent.indexOf('Chrome') !== -1 || userAgent.indexOf('Edg') !== -1)) {
			// Windows Chrome、もしくはWindows Edge
			if(office_name.length > 15){
				office_name = office_name.substring(0, 15) + '...';
			}
		}
		subject = `【${staff_name} 様】求人説明希望`;
		if ($('body').hasClass('page-my')) {
			body = [
				`【スタッフ名】${staff_name} 様`,
				`【スタッフNo】107135329341`,
				`【仕事番号】${job_no}`,
				`【勤務先名】${office_name}`,
				`【職種】${occupation}`,
				'お問い合わせ、ご予約内容',
				'※求人説明をご希望の場合は、こちらのフリースペースに①勤務先名　②希望の日時を記載ください。%0D%0A%0D%0A',
			];
		} else {
			body = [
				`【スタッフ名】${staff_name} 様`,
				`【スタッフNo】${staff_id}`,
				`【仕事番号】${job_no}`,
				`【勤務先名】${office_name}`,
				`【職種】${occupation}`,
				'【お電話可能な日時】',
				'候補①',
				'候補②',
				'候補③%0D%0A',
			];
		}
	
		signature = [
			'フリーダイヤル：0120-353-161',
			'営業時間',
			'月～金　9：30～19：00',
			'祝・土　9：30～18：00　※日曜　定休%0D%0A',
		];
	
		signature2 = [
			'【その他お問い合わせ内容】',
			'※複数の求人説明がご希望の場合は、こちらのフリースペースに勤務先名を記載ください。',
		];
		
	
		mail = to;
				mail += '?subject=' + subject;
				mail += '&body=' + body.join(encodeURIComponent(lineFeed)) + signature.join(encodeURIComponent(lineFeed)) + signature2.join(encodeURIComponent(lineFeed));
	
		console.log('mail全文の文字数::' + mail.replace(/%0D%0A/g, '').length);
	
		if (
			(userAgent.indexOf('Windows') !== -1 || 
			userAgent.indexOf('Win16') !== -1 || 
			userAgent.indexOf('Win32') !== -1 || 
			userAgent.indexOf('Win64') !== -1) 
			&& 
			userAgent.indexOf('Android') === -1
			&&
			(userAgent.indexOf('Chrome') !== -1 || userAgent.indexOf('Edg') !== -1)) {
			// Windows Chrome、もしくはWindows Edge
			if(mail.replace(/%0D%0A/g, '').length > maxlen) {
				mail = to;
					mail += '?subject=' + subject;
					mail += '&body=' + body.join(encodeURIComponent(lineFeed)) + signature2.join(encodeURIComponent(lineFeed));
			}
			if(mail.replace(/%0D%0A/g, '').length > maxlen) { 
				mail = to;
				mail += '?subject=' + subject;
				mail += '&body=' + body.join(encodeURIComponent(lineFeed));
			}
		}
	
		
		console.log('mail::' + mail.replace(/%0D%0A/g, ''));
		console.log('mail::' + mail.replace(/%0D%0A/g, '').length);
		return mail;
	
	}

	/**
	 * 登録情報変更メール作成
	 *
	 * @memberof MailerSettings
	 * @return {undefined}
	 */
	 init_2() {
		console.log('MailerSettings.init 2:登録情報変更メール');
		const lineFeed = "\r\n";
		const to = 'mailto:resort@a-sta.jp';
		let mail = '';
		let subject = '';
		let body = '';
		const staff_name = $('#staff_name').val()
	
		subject = `【${staff_name} 様】マイページ内からのお問い合わせ`;

		body = [
				`【スタッフ名】${staff_name} 様%0D%0A`,
				'【お問い合わせ内容】',
				'お問い合わせ内容をご入力ください。',
		];
		
		mail = to;
				mail += '?subject=' + subject;
				mail += '&body=' + body.join(encodeURIComponent(lineFeed));
	
		console.log('mail全文の文字数::' + mail.replace(/%0D%0A/g, '').length);
			
		console.log('mail::' + mail.replace(/%0D%0A/g, ''));
		console.log('mail::' + mail.replace(/%0D%0A/g, '').length);
		return mail;
	
	}

	/**
	 * 求人説明希望メール
	 *
	 * @memberof MailerSettings
	 * @return {undefined}
	 */
	init_3() {
		console.log('MailerSettings.init 3:求人説明希望メール');
		const lineFeed = "\r\n";
		const to = 'mailto:resort@a-sta.jp';
		let mail = '';
		let subject = '';
		let body = '';
		const staff_name = $('#staff_name').val();
		const staff_id = $('#staff_id').val();

		subject = `【${staff_name} 様】マイページ内からのお問い合わせ`;

		body = [
			`【スタッフ名】${staff_name} 様%0D%0A`,
			`【スタッフNo】${staff_id}`,
			'営業時間',
			'月～金　9:30～19:00',
			'祝・土　9:30～18:00　※日曜　定休',
			'%0D%0A',
			'【お問い合わせ、ご予約内容】',
			'※求人説明をご希望の場合は、こちらのフリースペースに①勤務先名　②希望の日時を記載ください。',
		];

		mail = to;
		mail += '?subject=' + subject;
		mail += '&body=' + body.join(encodeURIComponent(lineFeed));

		console.log('mail全文の文字数::' + mail.replace(/%0D%0A/g, '').length);

		console.log('mail::' + mail.replace(/%0D%0A/g, ''));
		console.log('mail::' + mail.replace(/%0D%0A/g, '').length);
		return mail;
		}
}
// $('.js-close-modal, .js-from-tel-menu').on('click', function () {
// 	const targetModalSelector = $(this).data('target');
// 	const fromTelMenu = $(this).data('from') === 'tel-menu';
  
// 	if (fromTelMenu && targetModalSelector) {
// 	  $(targetModalSelector).data('mail-id', '3');
// 	}
//   });


//   $('#modal--job-entry-init3, #modal--job-entry-sp-init3').on('shown.bs.modal', function () {
// 	const $modal = $(this);
// 	const $mailBtn = $modal.find('.js-mail-trigger');
// 	const mailId = $modal.data('mail-id') || '1'; 
  
// 	$mailBtn.attr('data-mail-id', mailId);
  

// // モーダルが開く時に data-mail-id を切り替え

// let openedFromTelMenu = false;

// $(document).on('click', '[data-bs-toggle="modal"][href="#modal--job-entry"]', function () {
// 	const from = $(this).data('from');
// 	if (from === 'tel-menu') {
// 		openedFromTelMenu = true;
// 	}
// });

